export default function Problem() {
  const problems = [
    {
      icon: 'ri-time-line',
      title: '급하게 사람이 필요한데',
      description: '당장 내일 출근할 사람을 찾기가 너무 어렵습니다'
    },
    {
      icon: 'ri-user-search-line',
      title: '검증된 사람을 찾고 싶은데',
      description: '경력과 신뢰도를 확인할 방법이 없어 불안합니다'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '채용 비용이 부담스러운데',
      description: '광고비만 나가고 제대로 된 지원자가 없습니다'
    },
    {
      icon: 'ri-chat-3-line',
      title: '소통이 어려운데',
      description: '연락이 안 되거나 약속을 지키지 않는 경우가 많습니다'
    }
  ];

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 bg-white rounded-full border border-gray-200 mb-6">
            <span className="text-sm font-medium text-gray-700" style={{ fontFamily: "'Pretendard', sans-serif" }}>사장님들의 고민</span>
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.02em' }}>
            이런 어려움 겪고 계신가요?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: "'Pretendard', sans-serif" }}>
            유흥업 채용의 가장 큰 문제점들을 정확히 파악했습니다
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl p-8 hover:shadow-lg transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 bg-gray-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-gray-900 transition-colors duration-300">
                  <i className={`${problem.icon} text-2xl text-gray-900 group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                    {problem.title}
                  </h3>
                  <p className="text-base text-gray-600 leading-relaxed" style={{ fontFamily: "'Pretendard', sans-serif" }}>
                    {problem.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
